import { useTranslation } from "react-i18next";
import { useSelector } from "src/store";

import { selectGroups } from "@dashboard/groups/store/selectors";
import { getNestedGroupsWithIndentation } from "@dashboard/groups/utils";
import { useCurrentWorkspace } from "@dashboard/workspaces/api/helpers";
import { PermissionService } from "@services/permissionService/permissionService";
import { SelectOption } from "@shared/form/SelectField/SelectField.types";

export const useVisibilityOptions = () => {
    const { t } = useTranslation(["common"]);
    const { data: workspace } = useCurrentWorkspace();
    const workspaceGroups = useSelector(selectGroups);
    const { workspaceAbility, groupAbility } = PermissionService();
    const canManageWorkspace = workspaceAbility(workspace).can("manage", "File");

    let workspaceOptions: SelectOption[] = [];
    let groupOptions: SelectOption[] = [];

    if (workspace && canManageWorkspace) {
        workspaceOptions = [
            {
                label: workspace.name,
                value: workspace.id,
                category: t("common:label.workspace"),
            },
        ];
    }

    const nestedGroups = getNestedGroupsWithIndentation(workspaceGroups);
    if (nestedGroups.length) {
        const accessibleGroups = nestedGroups.filter((group) =>
            groupAbility(workspaceGroups.find((g) => g.id === group.value) || null, workspace).can("manage", "File"),
        );
        groupOptions = accessibleGroups.map((group) => ({
            label: group.label,
            value: group.value,
            category: t("common:label.groups"),
        }));
    }

    return [...workspaceOptions, ...groupOptions];
};
